import { nextTick } from 'vue'
// import html2pdf from 'html2pdf.js'
import Html2Pdf from "./html2Pdf"
import config from '../config.js';

const TYPES = config.pageSizeType;
// const htmlToPdf2 = {
//   getPdf (title) {
//     nextTick(() => {
//       const element = document.getElementById('tpl_box')
//       const options = {
//         margin: [0, 0, 0, 0],
//         filename: title + '.pdf',
//         image: { type: 'jpeg', quality: 0.98 },
//         html2canvas: { scale: 2, allowTaint: true },
//         // html2canvas: { scale: 2 },
//         jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
//         enableLinks: true,
//         pagebreak: { mode: 'legacy', after: '.avoidThisRow' },
//         // pagebreak: { mode: 'css', after: '.avoidThisRow' },
//       }
//       document.getElementById('basicInfo').style.paddingTop = '0px!important'
//       html2pdf().set(options).from(element).save()
//     })
//   }
// }

// export default htmlToPdf2;
function getElementTop(element) {
  let actualTop = element.offsetTop;
  let current = element.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  return actualTop;
}

function fract(num){
  return num - Math.trunc(num);
}
let pdfFooterPadding = 40;
let oldMarginVal = 0;


export default {
  instance: new Html2Pdf(),
  getPdf (title = '', downloadType = 'pdf', afterCallback = () => {}, failCallback= () => {}) {
    nextTick(() => {
      try {
      const element = document.getElementById('tpl_box')
      // try {
      //   const pageHeightSize = parseFloat(element.dataset.containerminheightpx) || window.pageHeightSize || 842;
      //   console.log('element===>', element.dataset.containerminheightpx, pageHeightSize)
      //   // 处理分页问题
      //   let contentlistEles = document.querySelectorAll('.content_list_common');
      //   let pdfWapEleTop = getElementTop(element);
      //   if (contentlistEles.length && downloadType != 'image') {
      //     for (let index = 0; index < contentlistEles.length; index++) {
      //       const itemEle = contentlistEles[index];
      //       let curItemElePx = getElementTop(itemEle) - pdfWapEleTop + itemEle.offsetHeight;
      //       let curItemEleTopPx = getElementTop(itemEle) - pdfWapEleTop;
      //       let xiaoshu = fract((curItemElePx / pageHeightSize).toFixed(3));
      //       let xiaoshuTop = fract((curItemEleTopPx / pageHeightSize).toFixed(3));
      //       let spaceNum = (pageHeightSize - pdfFooterPadding) / pageHeightSize;
      //       console.log(xiaoshu, spaceNum)
      //       if (xiaoshu >= spaceNum && index != (contentlistEles.length - 1)) {// 下边缘在安全区外
      //         if (itemEle.style.marginBottom) oldMarginVal = parseFloat(itemEle.style.marginBottom) || 0;
      //         itemEle.style.marginBottom = `${pdfFooterPadding + oldMarginVal}px`;
      //         setTimeout(() => {
      //           itemEle.style.marginBottom = `${oldMarginVal}px`;
      //         }, 1000 * 5);
      //         // console.log(xiaoshu, spaceNum, itemEle.style.padding)
      //       } else if (xiaoshuTop >= spaceNum) {// 上边缘在安全区外
      //         if (itemEle.style.marginTop) oldMarginVal = parseFloat(itemEle.style.marginTop) || 0;
      //         itemEle.style.marginTop = `${pdfFooterPadding + oldMarginVal}px`;
      //         setTimeout(() => {
      //           itemEle.style.marginTop = `${oldMarginVal}px`;
      //         }, 1000 * 5);
      //       } else if (xiaoshu < xiaoshuTop && (1 - xiaoshuTop) * pageHeightSize <= pdfFooterPadding * 2) {// 同一项上边缘在安全区内,下边缘在安全区内,中间跨越页面(这种情况下边缘比率将小于上边缘)
      //         // 增加marginTop值使其跨越分页
      //         // 计算需要增加的marginTop值
      //         if (itemEle.style.marginTop) oldMarginVal = parseFloat(itemEle.style.marginTop) || 0;
      //         let addmarginTop = (1 - xiaoshuTop) * pageHeightSize + oldMarginVal + 30;
      //         itemEle.style.marginTop = `${addmarginTop}px`;
      //         setTimeout(() => {
      //           itemEle.style.marginTop = `${oldMarginVal}px`;
      //         }, 1000 * 5);
      //       }
      //     }

      //     // contentlistEles.forEach((itemEle, index) => {
      //     //   let curItemElePx = getElementTop(itemEle) - pdfWapEleTop + itemEle.offsetHeight;
      //     //   let curItemEleTopPx = getElementTop(itemEle) - pdfWapEleTop;
      //     //   let xiaoshu = fract((curItemElePx / TYPES['a4'][1]).toFixed(3));
      //     //   let xiaoshuTop = fract((curItemEleTopPx / TYPES['a4'][1]).toFixed(3));
      //     //   let spaceNum = (TYPES['a4'][1] - pdfFooterPadding) / TYPES['a4'][1];
      //     //   console.log(xiaoshu, spaceNum)
      //     //   if (xiaoshu >= spaceNum && index != (contentlistEles.length - 1)) {// 下边缘在安全区外
      //     //     if (itemEle.style.marginBottom) oldMarginVal = parseFloat(itemEle.style.marginBottom) || 0;
      //     //     itemEle.style.marginBottom = `${pdfFooterPadding + oldMarginVal}px`;
      //     //     setTimeout(() => {
      //     //       itemEle.style.marginBottom = `${oldMarginVal}px`;
      //     //     }, 1000 * 5);
      //     //     // console.log(xiaoshu, spaceNum, itemEle.style.padding)
      //     //   } else if (xiaoshuTop >= spaceNum) {// 上边缘在安全区外
      //     //     if (itemEle.style.marginTop) oldMarginVal = parseFloat(itemEle.style.marginTop) || 0;
      //     //     itemEle.style.marginTop = `${pdfFooterPadding + oldMarginVal}px`;
      //     //     setTimeout(() => {
      //     //       itemEle.style.marginTop = `${oldMarginVal}px`;
      //     //     }, 1000 * 5);
      //     //   } else if (xiaoshu < xiaoshuTop && (1 - xiaoshuTop) * TYPES['a4'][1] <= pdfFooterPadding * 2) {// 同一项上边缘在安全区内,下边缘在安全区内,中间跨越页面(这种情况下边缘比率将小于上边缘)
      //     //     // 增加marginTop值使其跨越分页
      //     //     // 计算需要增加的marginTop值
      //     //     if (itemEle.style.marginTop) oldMarginVal = parseFloat(itemEle.style.marginTop) || 0;
      //     //     let addmarginTop = (1 - xiaoshuTop) * TYPES['a4'][1] + oldMarginVal + 10;
      //     //     itemEle.style.marginTop = `${addmarginTop}px`;
      //     //     setTimeout(() => {
      //     //       itemEle.style.marginTop = `${oldMarginVal}px`;
      //     //     }, 1000 * 5);
      //     //   }
      //     // });
      //   }
      // } catch (error) {}
      const html2pdf = new Html2Pdf({
          title,
          el: element,
          type: "a4",
          elId: 'tpl_box',
          beforeFn() {
              console.log("before")
          },
          afterFn() {
              console.log("after")
              afterCallback && afterCallback()
          }
      })
      html2pdf.start(downloadType);
      } catch (error) {
        console.log('getPdf catch err:', error);
        failCallback && failCallback(error);
      }
    })
  }
}
